import Vue from 'vue';

// 定义和配置各种指令
Vue.directive('onlyNumber', {
  inserted (el, binding, vnode) {
    const db = binding.value;
    let iscancel = false;
    const inputEvent = e => {
      if (iscancel) {
        return false;
      }
      let value = e.target.value;
      let v = value;
      // 验证为空
      if (value === undefined || value === null) {
        e.target.value = '';
        return false;
      } else if (isNaN(value) && !/^-$/.test(value)) {
        value = '';
      } else if (!/^[+-]?\d*\.{0,1}\d{0,1}$/.test(value)) {
        value = value.replace(/\.\d{2,}$/, value.substr(value.indexOf('.'), 3));
      }
      // 非数字
      if (isNaN(value)) {
        // 验证"."和"-"以及非数字
        if (value === '.') {
          v = '0.';
        } else if (value !== '-') {
          v = parseFloat(value);
          if (isNaN(v)) {
            v = '';
          }
        }
      } else if (v !== '') {
        // 验证不合法数字
        let temp = value.split('.')
        if (temp.length > 2) {
          temp.length = 2;
        }
        temp[0] = temp[0] > 9 || temp[0].length > 1 ? parseInt(temp[0], 10) : temp[0];// 处理00086这种数字
        if (Object.is(temp[0], -0)) {
          temp[0] = '-0';
        }
        v = temp.length === 2 ? temp.join('.') : temp[0];
      }
      if (typeof db === 'function') {
        v = db(v)
      }
      // e.target.value=v;
      if (Object.is(v, -0)) {
        v = '-0';
      }
      vnode.data.model.callback(v);
    }
    el.oninput = inputEvent;
    // 解决输入中文的问题
    el.addEventListener('compositionstart', e => {
      iscancel = true;
    });
    el.addEventListener('compositionend', e => {
      iscancel = false;
      inputEvent(e)
    });
  }

})



// WEBPACK FOOTER //
// ./src/utils/directives.js